import React from 'react';

import styles from 'components/SignInPage/SignInPage.module.css';

import { ReactComponent as LogoImage } from './signInPageLogoImage.svg';

export const SignInPageLogo = () => (
  <LogoImage className={styles.SignInPage__Logo} />
);
